<div
  [ngClass]="
    switchBtnHidden
      ? 'p-form-origin-to-destination'
      : 'p-form-origin-to-destination p-form-origin-to-destination--has-inverse'
  "
>
  <div
    class="p-form-origin-to-destination__item p-form-origin-to-destination__item--origin"
    [ngClass]="{ 'is-active': isError(status.origin) }"
  >
    <ng-content select="[origin]"></ng-content>
  </div>
  <ng-container *ngIf="!switchBtnHidden">
    <div class="p-form-origin-to-destination__inverse">
      <button id="{{ id }}" class="p-form-origin-to-destination__inverse-btn" (click)="switch()">
        <span class="u-visually-hidden">{{ staticMessage.swapAirportCity | staticMsg }}</span>
      </button>
    </div>
  </ng-container>
  <div
    class="p-form-origin-to-destination__item p-form-origin-to-destination__item--destination"
    [ngClass]="{ 'is-active': isError(status.destination) }"
  >
    <ng-content select="[destination]"></ng-content>
  </div>
</div>
<ng-container *ngFor="let status of [status.origin, status.destination]">
  <ng-container *ngIf="isError(status)">
    <asw-validation-error [errorMessage]="status.errors[0]"></asw-validation-error>
  </ng-container>
</ng-container>
